// Generated by ReScript, PLEASE EDIT WITH CARE


function isCourierBookingFlowEnabled(mobile) {
  return true;
}

export {
  isCourierBookingFlowEnabled ,
}
/* No side effect */
